import { Center, Grid, GridItem } from "@chakra-ui/react";
import Header from "@components/Header";
import LandingHeader from "@components/Landing/HeaderNav/SimpleHeader";
import HeaderNav from "@components/Landing/HeaderNav/HeaderNav";
import Sidebar from "@components/Sidebar";
import { usePathname } from "next/navigation";
import { ReactNode } from "react";

const AppLayout = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname();

  const is404 = pathname === "/404/";
  const isBlocked = pathname === "/blocked/";

  const showLandingLayout =
    pathname === "/" ||
    pathname === "/institutions/" ||
    pathname.includes("/insights/resources/") ||
    pathname === "/terms-of-service/" ||
    pathname === "/privacy-policy/";

  const hideWalletButton =
    pathname === "/bridge/" ||
    pathname === "/bridge-agETH/" ||
    pathname === "/avs/";

  if (showLandingLayout || is404 || isBlocked) {
    return (
      <>
        {!isBlocked && (
          <Center flexDir="column">
            {is404 ? <LandingHeader /> : <HeaderNav />}
          </Center>
        )}
        {children}
      </>
    );
  }

  return (
    <>
      <Grid
        templateColumns={{
          base: "100vw",
          xl: "280px 1fr",
        }}
      >
        {
          <GridItem display={{ base: "none", xl: "inherit" }}>
            <Sidebar />
          </GridItem>
        }
        <GridItem>
          <Header
            secondaryVariant={false}
            kelplogo={false}
            hideWalletButton={hideWalletButton}
          />
          {children}
        </GridItem>
      </Grid>
    </>
  );
};

export default AppLayout;
